import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import CmsBlock from 'Component/CmsBlock';

import './PaymentMethods.style';

/** @namespace PeggysagePwa/Component/PaymentMethods/Component */
export class PaymentMethodsComponent extends PureComponent {
    static propTypes = {
        hasTitle: PropTypes.bool,
        title: PropTypes.string
    };

    static defaultProps = {
        hasTitle: true,
        title: __('Payment methods')
    };

    renderTitle() {
        const { hasTitle, title } = this.props;

        if (!hasTitle || title === '') {
            return null;
        }

        return (
            <h3 block="PaymentMethods" elem="Title">
                { title }
            </h3>
        );
    }

    render() {
        return (
            <div block="PaymentMethods">
                { this.renderTitle() }
                <div block="PaymentMethods" elem="Content">
                    <CmsBlock identifier="payment_methods" />
                </div>
            </div>
        );
    }
}

export default PaymentMethodsComponent;
